module.exports = __webpack_public_path__ + "static/media/Typhoon_MK_II_25mm_Stabilised_Naval_Gun_Systems_01.f88650e3.mp4";